// Library — continuing watching shelf + breels (coming soon) + merch (coming soon)
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Play, Film, ShoppingBag, Clapperboard } from "lucide-react";
import { Toaster } from "sonner";
import ComingSoon from "../components/ComingSoon";

export default function Library() {
  const [streams, setStreams] = useState([]);

  // BReels + Merch fetches are commented out until those surfaces ship.
  // Backend endpoints /api/breels and /api/merch stay live for Owner HQ.
  useEffect(() => {
    api.get("/streams").then(({ data }) => setStreams(data.slice(0, 6)));
  }, []);

  return (
    <div className="max-w-[1500px] mx-auto space-y-16" data-testid="library-page">
      <Toaster theme="dark" position="top-center" />
      <div>
        <div className="label-eyebrow mb-3">// Library</div>
        <h1 className="font-display font-black text-4xl lg:text-6xl tracking-tighter">Continue your journey.</h1>
      </div>

      <section className="space-y-4">
        <div className="flex items-center gap-3"><Play className="w-4 h-4 text-nexus-cyan" /><h2 className="font-display text-sm tracking-[0.3em] uppercase">Continue watching</h2></div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {streams.map((s) => (
            <Link to={`/watch/${s.id}`} key={s.id} className="group">
              <div className="aspect-video overflow-hidden border border-white/10 relative">
                <img src={s.thumbnail} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/20"><div className="h-full" style={{ width: `${Math.random() * 80 + 10}%`, background: "#00F0FF" }} /></div>
              </div>
              <div className="mt-3 text-sm">{s.title}</div>
              <div className="text-[11px] text-white/40">{s.creator_name}</div>
            </Link>
          ))}
        </div>
      </section>

      <section className="space-y-4">
        <div className="flex items-center gap-3"><Film className="w-4 h-4 text-nexus-violet" /><h2 className="font-display text-sm tracking-[0.3em] uppercase">BReels · AI Short Films</h2></div>
        <ComingSoon
          title="BReels is loading"
          subtitle="Our AI short-film studio is being rebuilt as its own flagship project. New reels pause here until BReels v2 ships."
          accent="violet"
          icon={Clapperboard}
          testId="library-breels-coming-soon"
          compact
        />
      </section>

      <section className="space-y-4">
        <div className="flex items-center gap-3"><ShoppingBag className="w-4 h-4 text-nexus-amber" /><h2 className="font-display text-sm tracking-[0.3em] uppercase">Elysium Merch</h2></div>
        <ComingSoon
          title="Elysium Wear incoming"
          subtitle="Creator-designed drops, limited runs, and stream-overlay checkout. The storefront powers up with the next NEXUS wave."
          accent="amber"
          icon={ShoppingBag}
          testId="library-merch-coming-soon"
          compact
        />
      </section>
    </div>
  );
}
